export default from './PrivacyPage';



// WEBPACK FOOTER //
// ./src/components/Privacy/index.js